import { render, staticRenderFns } from "./CompanyVendors.vue?vue&type=template&id=15c436b2&"
import script from "./CompanyVendors.vue?vue&type=script&lang=js&"
export * from "./CompanyVendors.vue?vue&type=script&lang=js&"
import style0 from "./CompanyVendors.vue?vue&type=style&index=0&id=15c436b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports